<template>
  <v-card :loading="loading" class="p-3 pt-0" flat>
    <mixed-table :columns="columns" :data="data" :fetch-data="getDataForTable" :reload-table="reloadTable"
                 :tbProps="tableProps"/>
  </v-card>
</template>
<script>
import {debounce} from "../../../custom";
import {dataTableProps} from "../../../main";
import FiltersTable from "../../../components/Table/filtersTable.vue";
import MixedTable from "../../../components/Table/MixedTable.vue";

export default {
  name: "serviceMonitoring",
  components: {MixedTable, FiltersTable},
  data() {
    return {
      walletHistoryDialog: false,
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      serverTime: {},
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'نام کاربر',
          name: 'user.name',
          transform: (val) => {
            return val.data.user.name + ' ' + val.data.user.lastName
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'عنوان',
          name: 'title',
          transform: (val) => {
            return val.data.title
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مبلغ نردبان',
          name: 'amount',
          transform: (val) => {
            return val.data.amount ? val.data.amount : 'وجود ندارد';
          },
          orderable: false,
          searchable: true,
        },
        {
          label: 'اخرین آپدیت',
          name: 'updated_at_diff',
          primary: true,
          orderable: true,
          searchable: true,
        },
        {
          label: 'تاریخ ثبت',
          name: 'created_at_p',
          orderable: true,
          searchable: true,
        },
      ],
      tab: '',
      data: {},
      url: `${url}/admin/monitoring/service`,
      timer: null,
      amount: '',
      moreInformation: false,
      cafeBazarList: false,
      loading: false,
      adsInformation: [],
      walletHistory: {},
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }

  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: query,
        params: [url, query],
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.data = data;
          vm.loading = false;
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 1000);
    },
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url, this.tableProps);

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    });
  },
}
</script>